"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = require("react");
var useCss_1 = require("./useCss");
var emptyStylesFactory = function () { return ({}); };
exports.useStyles = function (factory) {
    if (factory === void 0) { factory = emptyStylesFactory; }
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var _a = useCss_1.useCss(), css = _a.css, theme = _a.theme;
    return react_1.useMemo(function () {
        var map = factory.apply(void 0, __spreadArrays([theme], args));
        var classes = Object.keys(map).reduce(function (all, className) {
            var _a;
            return (__assign(__assign({}, all), (_a = {}, _a[className] = css(map[className]), _a)));
        }, {});
        return { classes: classes, css: css, theme: theme };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, __spreadArrays(args, [css, factory, theme]));
};
//# sourceMappingURL=useStyles.js.map